import Client from '../hooks/useAxios';

export const Login = async (data) => {
  const response = await Client().post('/auth/login', data);
  return response.data;
};

export const postGuest = async (data) => {
  const response = await Client().post('/guest', data);
  return response.data;
};

export const postGuestReports = async () => {
  const response = await Client().post('/guest/reports');
  return response.data;
};

export const getGuestReportsPost = async (value) => {
  const response = await Client().post('/guest/get-reports', { timeSelect: value });
  return response.data;
};